module.exports = __webpack_public_path__ + "86c4aa127c5287572e37da5ac0d8ddfe.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/arrow-next.png
// module id = 47
// module chunks = 0